type UniversalCard = { source: 'universal' };
type LegacyCard = {
  source: 'legacy';
  kind: 'html' | 'image' | 'element';
  family_key: string;
};

export const mergeOnboardingCards = <
  U extends UniversalCard,
  L extends LegacyCard,
>(universal: U[], legacy: L[]): Array<U | L> => {
  if (universal.length === 0) return legacy;
  const nonShadowedLegacy = legacy.filter((card) => !(
    card.kind === 'html' && card.family_key === 'sophisticated-html-v2'
  ));
  return [...universal, ...nonShadowedLegacy];
};
